import { API_URL } from "../constants/constants"

export const updateUserName = async (sessionToken, username) => {
  try {
    const response = await fetch(`${API_URL}/user/update-username`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionToken ? `Bearer ${sessionToken}` : "",
      },
      body: JSON.stringify({ username: username }),
    })

    return await response.json()
  } catch (error) {
    console.error("Error fetching boxes:", error)
  }
}
